import { render, staticRenderFns } from "./download_hn.vue?vue&type=template&id=ffafdc16&scoped=true&"
import script from "./download_hn.vue?vue&type=script&lang=js&"
export * from "./download_hn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffafdc16",
  null
  
)

export default component.exports